export default "__VITE_ASSET__BSWlkyN2__"